import { fork, take, call, put } from 'redux-saga/effects'

// import { fetchTimezoneResponse } from './actions'
import types from './types'
import { apiDirect, postAPIWithoutModule } from '../../api/generic'
import { checkContentAccessResponse, getLoginLogoResponse, getNewContentCountResponse, getSmartBarResponse } from './actions'

// export function* doTimezoneFetch() {
//   while (true) {
//       const { payload } = yield take(types.TIMEZONE_FETCH)
//       const response = yield call(postAPIWithoutModule, payload)
//       yield put(fetchTimezoneResponse(response))
//   }
// }

export function* doCheckContentAccess() {
  while (true) {
    const { payload } = yield take(types.CONTENT_ACCESS)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(checkContentAccessResponse(response))
  }
}

export function* doGetSmartBar() {
  while (true) {
    const { payload } = yield take(types.SMART_BAR)
    const response = yield call(postAPIWithoutModule, payload)
    yield put(getSmartBarResponse(response))
  }
}

export function* doGetLoginLogo() {
  while (true) {
      const { payload } = yield take(types.LOGIN_LOGO)
      const response = yield call(apiDirect, payload)
      yield put(getLoginLogoResponse(response))
  }
}

export function* doGetNewContentCount() {
  while (true) {
      const { payload } = yield take(types.NEW_CONTENT_COUNT)
      const response = yield call(postAPIWithoutModule, payload)
      yield put(getNewContentCountResponse(response))
  }
}

function* home() {
  // yield fork(doTimezoneFetch)
  yield fork(doCheckContentAccess)
  yield fork(doGetSmartBar)
  yield fork(doGetLoginLogo)
  yield fork(doGetNewContentCount)
}

export default home